import "./edit-vehicle.scss";

import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import ListVehicleTransaction from "@domain/vehicle-transaction/list-vehicle-transaction/list-vehicle-transaction";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormVehicle from "../form-vehicle/form-vehicle";
import { useEditVehicle } from "./edit-vehicle.hook";
import FormVehicleView from "./view-vehicle";

export function EditVehicle() {
  const { getUserRole } = useUserIdentityContext();
  const userRole = getUserRole().name;
  const {
    vehicleData,
    isLoading,
    vehicleError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditVehicle();

  const title =
    userRole === LocalRole.CardOwner ? (
      <h1>
        {vehicleData?.make} {vehicleData?.model}
      </h1>
    ) : (
      <h1>Edit Vehicle</h1>
    );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      {userRole === LocalRole.CardOwner ? (
        <>
          <FormVehicleView data={vehicleData} />
        </>
      ) : (
        <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
          <FormVehicle />
          <ListVehicleTransaction />
        </section>
      )}
    </div>
  );

  return (
    <div id="EditVehicle" className="vehicle">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        {userRole !== LocalRole.CardOwner && (
          <HeaderButton actions={actions} onAction={handleAction} />
        )}
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {vehicleError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditVehicle;
